import Vue from "vue";
import VueAwesome from "vue-awesome";

export const registerIcon = () => {
  Vue.component("Icon", VueAwesome);
  VueAwesome.register({
    loginLogo: {
      width: 30.0,
      height: 30.0,
      paths: [
        {
          style: "fill:#512376",
          d:
            "M22.0996 0.230469L14.7813 15.0477L7.47052 0.230469H-0.000488281L14.7813 30.1899L29.5669 0.230469H22.0996Z",
        },
        {
          style: "fill:#512376",
          d:
            "M52.7362 0.230469L37.9531 30.1899H45.4204L52.7362 15.3714L60.0482 30.1899H67.5131L52.7362 0.230469Z",
        },
        {
          style: "fill:#512376",
          d:
            "M83.8733 15.3118C83.8733 10.9758 87.43 7.46198 91.7989 7.46198H104.781C102.101 3.12352 97.3065 0.22998 91.7989 0.22998C83.3902 0.22998 76.5762 6.98075 76.5762 15.3118C76.5762 23.6466 83.3902 30.4011 91.7989 30.4011C97.3065 30.4011 102.101 27.4989 104.781 23.1703H91.7989C87.43 23.1703 83.8733 19.654 83.8733 15.3118Z",
        },
        {
          style: "fill:#512376",
          d:
            "M128.624 0.230469L113.848 30.1899H121.315L128.624 15.3714L135.941 30.1899H143.413L128.624 0.230469Z",
        },
        {
          style: "fill:#512376",
          d:
            "M155.001 0.230469V29.7739H162.496V8.81016L178.154 29.7739V0.230469H155.001Z",
        },
      ],
    },

    company: {
      width: 16.67,
      height: 15,
      d:
        "M9.00008 3.83333V0.5H0.666748V15.5H17.3334V3.83333H9.00008ZM4.00008 13.8333H2.33341V12.1667H4.00008V13.8333ZM4.00008 10.5H2.33341V8.83333H4.00008V10.5ZM4.00008 7.16667H2.33341V5.5H4.00008V7.16667ZM4.00008 3.83333H2.33341V2.16667H4.00008V3.83333ZM7.33342 13.8333H5.66675V12.1667H7.33342V13.8333ZM7.33342 10.5H5.66675V8.83333H7.33342V10.5ZM7.33342 7.16667H5.66675V5.5H7.33342V7.16667ZM7.33342 3.83333H5.66675V2.16667H7.33342V3.83333ZM15.6667 13.8333H9.00008V12.1667H10.6667V10.5H9.00008V8.83333H10.6667V7.16667H9.00008V5.5H15.6667V13.8333ZM14.0001 7.16667H12.3334V8.83333H14.0001V7.16667ZM14.0001 10.5H12.3334V12.1667H14.0001V10.5Z",
    },
    report: {
      width: 20,
      height: 20,
      d:
        "M19.1666 6.66667C19.1666 7.58333 18.4166 8.33333 17.4999 8.33333C17.3499 8.33333 17.2083 8.31667 17.0749 8.275L14.1083 11.2333C14.1499 11.3667 14.1666 11.5167 14.1666 11.6667C14.1666 12.5833 13.4166 13.3333 12.4999 13.3333C11.5833 13.3333 10.8333 12.5833 10.8333 11.6667C10.8333 11.5167 10.8499 11.3667 10.8916 11.2333L8.76658 9.10833C8.63325 9.15 8.48325 9.16667 8.33325 9.16667C8.18325 9.16667 8.03325 9.15 7.89992 9.10833L4.10825 12.9083C4.14992 13.0417 4.16658 13.1833 4.16658 13.3333C4.16658 14.25 3.41658 15 2.49992 15C1.58325 15 0.833252 14.25 0.833252 13.3333C0.833252 12.4167 1.58325 11.6667 2.49992 11.6667C2.64992 11.6667 2.79159 11.6833 2.92492 11.725L6.72492 7.93333C6.68325 7.8 6.66658 7.65 6.66658 7.5C6.66658 6.58333 7.41658 5.83333 8.33325 5.83333C9.24992 5.83333 9.99992 6.58333 9.99992 7.5C9.99992 7.65 9.98325 7.8 9.94158 7.93333L12.0666 10.0583C12.1999 10.0167 12.3499 10 12.4999 10C12.6499 10 12.7999 10.0167 12.9333 10.0583L15.8916 7.09167C15.8499 6.95833 15.8333 6.81667 15.8333 6.66667C15.8333 5.75 16.5833 5 17.4999 5C18.4166 5 19.1666 5.75 19.1666 6.66667Z",
    },
    alert: {
      width: 20,
      height: 20,
      d:
        "M12.5 5H2.5V6.66667H12.5V5ZM12.5 8.33333H2.5V10H12.5V8.33333ZM2.5 13.3333H9.16667V11.6667H2.5V13.3333ZM14.1667 5V11.8167C13.9083 11.725 13.625 11.6667 13.3333 11.6667C11.95 11.6667 10.8333 12.7833 10.8333 14.1667C10.8333 15.55 11.95 16.6667 13.3333 16.6667C14.7167 16.6667 15.8333 15.55 15.8333 14.1667V6.66667H18.3333V5H14.1667Z",
    },
    alertSetting: {
      width: 20,
      height: 20,
      d:
        "M8.34167 17.5084C8.34167 18.425 9.08333 19.1667 10 19.1667C10.9167 19.1667 11.6583 18.425 11.6583 17.5084H8.34167ZM15.7333 14.0167V9.16669C15.7333 6.45835 13.8583 4.19169 11.325 3.59169V2.99169C11.325 2.25835 10.7333 1.66669 10 1.66669C9.26667 1.66669 8.675 2.25835 8.675 2.99169V3.59169C6.14167 4.19169 4.26667 6.45835 4.26667 9.16669V14.0167L2.5 15.7834V16.6667H17.5V15.7834L15.7333 14.0167ZM13.3333 10.8417H10.8333V13.3417H9.16667V10.8417H6.66667V9.16669H9.16667V6.66669H10.8333V9.16669H13.3333V10.8417Z",
    },
    alertDestination: {
      width: 20,
      height: 20,
      d:
        "M2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667ZM12.5 7.5C12.5 8.88333 11.3833 10 10 10C8.61667 10 7.5 8.88333 7.5 7.5C7.5 6.11667 8.61667 5 10 5C11.3833 5 12.5 6.11667 12.5 7.5ZM5 14.1667C5 12.5 8.33333 11.5833 10 11.5833C11.6667 11.5833 15 12.5 15 14.1667V15H5V14.1667Z",
    },
    alertSettings: {
      width: 20,
      height: 20,
      d:
        "M8.34167 17.5082C8.34167 18.4248 9.08333 19.1665 10 19.1665C10.9167 19.1665 11.6583 18.4248 11.6583 17.5082H8.34167ZM15.7333 14.0165V9.1665C15.7333 6.45817 13.8583 4.1915 11.325 3.5915V2.9915C11.325 2.25817 10.7333 1.6665 10 1.6665C9.26667 1.6665 8.675 2.25817 8.675 2.9915V3.5915C6.14167 4.1915 4.26667 6.45817 4.26667 9.1665V14.0165L2.5 15.7832V16.6665H17.5V15.7832L15.7333 14.0165ZM13.3333 10.8415H10.8333V13.3415H9.16667V10.8415H6.66667V9.1665H9.16667V6.6665H10.8333V9.1665H13.3333V10.8415Z",
    },

    gateway: {
      width: 20,
      height: 20,
      d:
        "M2.70033 5.12501C2.09199 5.35834 1.66699 5.97501 1.66699 6.66668V16.6667C1.66699 17.5833 2.40866 18.3333 3.33366 18.3333H16.667C17.592 18.3333 18.3337 17.5833 18.3337 16.6667V6.66668C18.3337 5.74168 17.592 5.00001 16.667 5.00001H6.91699L13.8003 2.21668L13.2337 0.833344L2.70033 5.12501ZM5.83366 16.6667C4.45033 16.6667 3.33366 15.55 3.33366 14.1667C3.33366 12.7833 4.45033 11.6667 5.83366 11.6667C7.21699 11.6667 8.33366 12.7833 8.33366 14.1667C8.33366 15.55 7.21699 16.6667 5.83366 16.6667ZM16.667 10H15.0003V8.33334H13.3337V10H3.33366V6.66668H16.667V10Z",
    },
    sensor: {
      width: 20,
      height: 20,
      d:
        "M12.4999 7.5H7.49993C7.0416 7.5 6.6666 7.875 6.6666 8.33333V18.3333C6.6666 18.7917 7.0416 19.1667 7.49993 19.1667H12.4999C12.9583 19.1667 13.3333 18.7917 13.3333 18.3333V8.33333C13.3333 7.875 12.9583 7.5 12.4999 7.5ZM9.99994 12.5C9.08327 12.5 8.33327 11.75 8.33327 10.8333C8.33327 9.91667 9.08327 9.16667 9.99994 9.16667C10.9166 9.16667 11.6666 9.91667 11.6666 10.8333C11.6666 11.75 10.9166 12.5 9.99994 12.5ZM5.87494 5.04167L7.04994 6.21667C7.80827 5.46667 8.84994 5 9.99994 5C11.1499 5 12.1916 5.46667 12.9499 6.21667L14.1249 5.04167C13.0666 3.98333 11.6083 3.33333 9.99994 3.33333C8.3916 3.33333 6.93327 3.98333 5.87494 5.04167ZM9.99994 0C7.4666 0 5.17493 1.025 3.5166 2.68333L4.6916 3.85833C6.04994 2.50833 7.92493 1.66667 9.99994 1.66667C12.0749 1.66667 13.9499 2.50833 15.2999 3.86667L16.4749 2.69167C14.8249 1.025 12.5333 0 9.99994 0Z",
    },
    tablet: {
      width: 20,
      height: 20,
      d:
        "M0.841341 5.83332L0.833008 14.1667C0.833008 15.0833 1.58301 15.8333 2.49967 15.8333H17.4997C18.4163 15.8333 19.1663 15.0833 19.1663 14.1667V5.83332C19.1663 4.91666 18.4163 4.16666 17.4997 4.16666H2.49967C1.58301 4.16666 0.841341 4.91666 0.841341 5.83332ZM15.833 5.83332V14.1667H4.16634V5.83332H15.833Z",
    },
    toilet: {
      width: 20,
      height: 20,
      d:
        "M14.6965 1.66663H15.2173C15.8336 1.66663 16.3333 2.1664 16.3333 2.78271V9.70283H14.6965V2.78271V1.66663ZM16.3337 18.3344V10.2982H3.33337C3.33337 13.448 5.3461 17.0703 8.29747 18.3344H16.3337Z",
    },
    website: {
      width: 20,
      height: 20,
      d:
        "M16.6666 3.33337H3.33329C2.41663 3.33337 1.67496 4.08337 1.67496 5.00004L1.66663 15C1.66663 15.9167 2.41663 16.6667 3.33329 16.6667H16.6666C17.5833 16.6667 18.3333 15.9167 18.3333 15V5.00004C18.3333 4.08337 17.5833 3.33337 16.6666 3.33337ZM12.5 15H3.33329V11.6667H12.5V15ZM12.5 10.8334H3.33329V7.50004H12.5V10.8334ZM16.6666 15H13.3333V7.50004H16.6666V15Z",
    },

    close: {
      width: 36,
      height: 36,
      d:
        "M15.2 2.25033L13.7498 0.800049L8.00005 6.54976L2.25033 0.800049L0.800049 2.25033L6.54976 8.00005L0.800049 13.7498L2.25033 15.2L8.00005 9.45033L13.7498 15.2L15.2 13.7498L9.45033 8.00005L15.2 2.25033Z",
    },
    back: {
      width: 36,
      height: 36,
      d:
        "M30 17H11.745L20.13 8.615L18 6.5L6 18.5L18 30.5L20.115 28.385L11.745 20H30V17Z",
    },
    arrow: {
      width: 24,
      height: 24,
      paths: [
        {
          style: "fill:#FFFFFF00",
          d:
            "M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z",
        },
        {
          d: "M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z",
        },
      ],
    },
    edit: {
      width: 36,
      height: 36,
      d:
        "M10.5 22.3751V25.5001H13.625L22.8417 16.2835L19.7167 13.1585L10.5 22.3751ZM25.2583 13.8668C25.5833 13.5418 25.5833 13.0168 25.2583 12.6918L23.3083 10.7418C22.9833 10.4168 22.4583 10.4168 22.1333 10.7418L20.6083 12.2668L23.7333 15.3918L25.2583 13.8668Z",
    },
    users: {
      width: 20,
      height: 20,
      d:
        "M2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667ZM12.5 7.5C12.5 8.88333 11.3833 10 10 10C8.61667 10 7.5 8.88333 7.5 7.5C7.5 6.11667 8.61667 5 10 5C11.3833 5 12.5 6.11667 12.5 7.5ZM5 14.1667C5 12.5 8.33333 11.5833 10 11.5833C11.6667 11.5833 15 12.5 15 14.1667V15H5V14.1667Z",
    },
    tenantUsers: {
      width: 20,
      height: 20,
      d:
        "M17.4997 4.16669V15.8334H19.1663V4.16669H17.4997ZM14.1663 15.8334H15.833V4.16669H14.1663V15.8334ZM11.6663 4.16669H1.66634C1.20801 4.16669 0.833008 4.54169 0.833008 5.00002V15C0.833008 15.4584 1.20801 15.8334 1.66634 15.8334H11.6663C12.1247 15.8334 12.4997 15.4584 12.4997 15V5.00002C12.4997 4.54169 12.1247 4.16669 11.6663 4.16669ZM6.66634 6.45835C7.69967 6.45835 8.54134 7.30002 8.54134 8.33335C8.54134 9.36669 7.69967 10.2084 6.66634 10.2084C5.63301 10.2084 4.79134 9.36669 4.79134 8.33335C4.79134 7.30002 5.63301 6.45835 6.66634 6.45835ZM10.4163 14.1667H2.91634V13.5417C2.91634 12.2917 5.41634 11.6667 6.66634 11.6667C7.91634 11.6667 10.4163 12.2917 10.4163 13.5417V14.1667Z",
    },

    longStayAlert: {
      width: 24,
      height: 24,
      d:
        "M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12ZM11 7H12.5V12.25L17 14.92L16.25 16.15L11 13V7Z",
    },
    failureAlert: {
      width: 24,
      height: 24,
      paths: [
        {
          style: "fill:rgba(0,0,0,0.25)",
          d: "M22 8V2L2 22H18V8H22Z",
        },
        {
          style: "fill:#616161",
          d: "M20 10V18H22V10H20ZM12 22V12L2 22H12ZM20 22H22V20H20V22Z",
        },
      ],
    },
    lowBatteryAlert: {
      width: 24,
      height: 24,
      d:
        "M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4ZM13 18H11V16H13V18ZM13 14H11V9H13V14Z",
    },

    checkboxOff: {
      width: 24,
      height: 24,
      d:
        "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
    },
    checkboxOn: {
      width: 24,
      height: 24,
      d:
        "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
    },
    userCircle: {
      width: 24,
      height: 24,
      d:
        "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z",
    },
    headerArrow: {
      width: 36,
      height: 36,
      d:
        "M13.41 14.5898L18 19.1698L22.59 14.5898L24 15.9998L18 21.9998L12 15.9998L13.41 14.5898Z",
    },
    companySelect: {
      width: 24,
      height: 24,
      d:
        "M4 10V17H7V10H4ZM10 10V17H13V10H10ZM2 22H21V19H2V22ZM16 10V17H19V10H16ZM11.5 1L2 6V8H21V6L11.5 1Z",
    },
    reload: {
      width: 21,
      height: 21,
      d:
        "M18.5333 3.46683C16.6 1.5335 13.9467 0.333496 11 0.333496C5.10668 0.333496 0.34668 5.10683 0.34668 11.0002C0.34668 16.8935 5.10668 21.6668 11 21.6668C15.9733 21.6668 20.12 18.2668 21.3067 13.6668H18.5333C17.44 16.7735 14.48 19.0002 11 19.0002C6.58668 19.0002 3.00001 15.4135 3.00001 11.0002C3.00001 6.58683 6.58668 3.00016 11 3.00016C13.2133 3.00016 15.1867 3.92016 16.6267 5.3735L12.3333 9.66683H21.6667V0.333496L18.5333 3.46683Z",
    },
    loading: {
      width: 30,
      height: 42,
      d:
        "M16.0001 10.5001V16.2501L23.6667 8.58341L16.0001 0.916748V6.66675C7.52841 6.66675 0.666748 13.5284 0.666748 22.0001C0.666748 25.0092 1.54841 27.8076 3.04341 30.1651L5.84175 27.3667C4.97925 25.7759 4.50008 23.9359 4.50008 22.0001C4.50008 15.6559 9.65591 10.5001 16.0001 10.5001ZM28.9567 13.8351L26.1584 16.6334C27.0017 18.2434 27.5001 20.0642 27.5001 22.0001C27.5001 28.3442 22.3442 33.5001 16.0001 33.5001V27.7501L8.33341 35.4167L16.0001 43.0834V37.3334C24.4717 37.3334 31.3334 30.4717 31.3334 22.0001C31.3334 18.9909 30.4517 16.1926 28.9567 13.8351Z",
    },
    checked: {
      width: 24,
      height: 24,
      d:
        "M8.9999 16.2L4.7999 12L3.3999 13.4L8.9999 19L20.9999 6.99998L19.5999 5.59998L8.9999 16.2Z",
    },
    closebtn: {
      width: 16,
      height: 16,
      d:
        "M17.0999 2.5316L15.4683 0.900024L8.9999 7.36845L2.53147 0.900024L0.899902 2.5316L7.36833 9.00002L0.899902 15.4685L2.53147 17.1L8.9999 10.6316L15.4683 17.1L17.0999 15.4685L10.6315 9.00002L17.0999 2.5316Z",
    },
    dragger: {
      width: 15,
      height: 9,
      d:
        "M0.5 8.125V9.625H15.5V8.125H0.5ZM0.5 4.375V5.875H15.5V4.375H0.5ZM0.5 0.625V2.125H15.5V0.625H0.5Z",
    },
    search: {
      width: 24,
      height: 24,
      d:
        "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z",
    },
    searchclose: {
      width: 32,
      height: 32,
      d:
        "M23.1998 10.2501L21.7495 8.7998L15.9998 14.5495L10.2501 8.7998L8.7998 10.2501L14.5495 15.9998L8.7998 21.7495L10.2501 23.1998L15.9998 17.4501L21.7495 23.1998L23.1998 21.7495L17.4501 15.9998L23.1998 10.2501Z",
    },

    toiletWoman: {
      width: 40,
      height: 40,
      d:
        "M23.9077 4C23.9077 6.22 22.113 8 19.8746 8C17.6362 8 15.8415 6.22 15.8415 4C15.8415 1.78 17.6362 0 19.8746 0C22.113 0 23.9077 1.78 23.9077 4ZM22.8994 28V40H16.8497V28H10.8L15.9221 12.74C16.4666 11.1 18.0194 10 19.7536 10H19.9956C21.7298 10 23.2624 11.1 23.8271 12.74L28.9491 28H22.8994Z",
    },
    toiletMan: {
      width: 40,
      height: 40,
      d:
        "M23.8809 4C23.8809 6.22 22.0878 8 19.8515 8C17.6152 8 15.8221 6.22 15.8221 4C15.8221 1.78 17.6152 0 19.8515 0C22.0878 0 23.8809 1.78 23.8809 4ZM15.8221 25V40H23.8809V25H26.903V14C26.903 11.8 25.0898 10 22.8736 10H16.8295C14.6133 10 12.8 11.8 12.8 14V25H15.8221Z",
    },
    toiletAccessible: {
      width: 40,
      height: 40,
      d:
        "M24 4C24 6.20914 22.2091 8 20 8C17.7909 8 16 6.20914 16 4C16 1.79086 17.7909 0 20 0C22.2091 0 24 1.79086 24 4ZM34 22V18C30.92 18.04 27.82 16.5 25.86 14.34L23.28 11.48C22.94 11.1 22.52 10.8 22.06 10.58C22.05 10.58 22.045 10.575 22.04 10.57C22.035 10.565 22.03 10.56 22.02 10.56H22C21.3 10.16 20.5 9.96 19.62 10.04C17.52 10.22 16 12.08 16 14.18V26C16 28.2 17.8 30 20 30H30V40H34V29C34 26.8 32.2 25 30 25H24V18.1C26.58 20.24 30.5 21.98 34 22ZM21.66 32C20.84 34.32 18.62 36 16 36C12.68 36 10 33.32 10 30C10 27.38 11.68 25.18 14 24.34V20.2C9.44 21.12 6 25.16 6 30C6 35.52 10.48 40 16 40C20.84 40 24.88 36.56 25.8 32H21.66Z",
    },
    toiletUnisex: {
      width: 40,
      height: 40,
      d:
        "M11.0808 4C11.0808 6.22 9.28771 8 7.05139 8C4.81506 8 3.02197 6.22 3.02197 4C3.02197 1.78 4.81506 0 7.05139 0C9.28771 0 11.0808 1.78 11.0808 4ZM3.02206 25V40H11.0809V25H14.103V14C14.103 11.8 12.2897 10 10.0735 10H4.02942C1.81324 10 0 11.8 0 14V25H3.02206ZM31.6995 40V28H37.7492L32.6271 12.74C32.0625 11.1 30.5299 10 28.7956 10H28.5536C26.8194 10 25.2666 11.1 24.7222 12.74L19.6001 28H25.6498V40H31.6995ZM32.7078 4C32.7078 6.22 30.913 8 28.6746 8C26.4363 8 24.6415 6.22 24.6415 4C24.6415 1.78 26.4363 0 28.6746 0C30.913 0 32.7078 1.78 32.7078 4Z",
    },

    toggleIcon: {
      width: 40,
      height: 40,
      d: "M27.65 14L20 21.6333L12.35 14L10 16.35L20 26.35L30 16.35L27.65 14Z",
    },

    footerLogo: {
      width: 128,
      height: 52,
      paths: [
        {
          d:
            "M19.6992 27.322C21.9072 27.322 23.7242 26.448 25.1272 24.815L23.3332 22.699C22.4132 23.688 21.2632 24.378 19.8142 24.378C17.1232 24.378 15.3752 22.147 15.3752 18.444C15.3752 14.787 17.3072 12.579 19.8832 12.579C21.1712 12.579 22.1602 13.177 23.0112 14.005L24.8052 11.843C23.7012 10.693 21.9762 9.658 19.8142 9.658C15.5132 9.658 11.9022 12.947 11.9022 18.559C11.9022 24.24 15.3982 27.322 19.6992 27.322ZM33.7329 27.322C38.2409 27.322 41.3459 23.941 41.3459 18.421C41.3459 12.901 38.2409 9.658 33.7329 9.658C29.2249 9.658 26.1199 12.878 26.1199 18.421C26.1199 23.941 29.2249 27.322 33.7329 27.322ZM33.7329 24.378C31.2029 24.378 29.5929 22.055 29.5929 18.421C29.5929 14.764 31.2029 12.579 33.7329 12.579C36.2629 12.579 37.8729 14.764 37.8729 18.421C37.8729 22.055 36.2629 24.378 33.7329 24.378ZM46.3031 27.322C47.5221 27.322 48.4191 26.356 48.4191 25.114C48.4191 23.872 47.5221 22.906 46.3031 22.906C45.1071 22.906 44.2101 23.872 44.2101 25.114C44.2101 26.356 45.1071 27.322 46.3031 27.322ZM52.1496 27H62.4536V24.148H55.5536V9.98H52.1496V27ZM71.3101 27.322C75.8181 27.322 78.9231 23.941 78.9231 18.421C78.9231 12.901 75.8181 9.658 71.3101 9.658C66.8021 9.658 63.6971 12.878 63.6971 18.421C63.6971 23.941 66.8021 27.322 71.3101 27.322ZM71.3101 24.378C68.7801 24.378 67.1701 22.055 67.1701 18.421C67.1701 14.764 68.7801 12.579 71.3101 12.579C73.8401 12.579 75.4501 14.764 75.4501 18.421C75.4501 22.055 73.8401 24.378 71.3101 24.378ZM89.5613 27.322C91.9303 27.322 93.9313 26.402 95.0813 25.275V17.593H89.0323V20.376H92.0453V23.734C91.5623 24.148 90.7343 24.378 89.9063 24.378C86.5713 24.378 84.8693 22.147 84.8693 18.444C84.8693 14.787 86.8473 12.579 89.6763 12.579C91.2173 12.579 92.1833 13.2 93.0113 14.005L94.8283 11.843C93.7243 10.716 92.0223 9.658 89.5613 9.658C85.0303 9.658 81.3963 12.947 81.3963 18.559C81.3963 24.24 84.9153 27.322 89.5613 27.322ZM105.496 27.322C110.004 27.322 113.109 23.941 113.109 18.421C113.109 12.901 110.004 9.658 105.496 9.658C100.988 9.658 97.8826 12.878 97.8826 18.421C97.8826 23.941 100.988 27.322 105.496 27.322ZM105.496 24.378C102.966 24.378 101.356 22.055 101.356 18.421C101.356 14.764 102.966 12.579 105.496 12.579C108.026 12.579 109.636 14.764 109.636 18.421C109.636 22.055 108.026 24.378 105.496 24.378Z",
        },
        {
          d:
            "M1.27926 51.15H2.73926V49.45L2.69926 48.53C3.12926 48.92 3.59926 49.14 4.08926 49.14C5.31926 49.14 6.46926 48.03 6.46926 46.11C6.46926 44.39 5.64926 43.26 4.26926 43.26C3.66926 43.26 3.08926 43.58 2.61926 43.98H2.57926L2.47926 43.4H1.27926V51.15ZM3.75926 47.93C3.45926 47.93 3.09926 47.82 2.73926 47.51V45.05C3.12926 44.66 3.46926 44.47 3.84926 44.47C4.61926 44.47 4.95926 45.06 4.95926 46.13C4.95926 47.35 4.43926 47.93 3.75926 47.93ZM10.0548 49.14C11.4548 49.14 12.7448 48.06 12.7448 46.21C12.7448 44.34 11.4548 43.26 10.0548 43.26C8.6548 43.26 7.3648 44.34 7.3648 46.21C7.3648 48.06 8.6548 49.14 10.0548 49.14ZM10.0548 47.94C9.2948 47.94 8.8648 47.26 8.8648 46.21C8.8648 45.15 9.2948 44.46 10.0548 44.46C10.8148 44.46 11.2448 45.15 11.2448 46.21C11.2448 47.26 10.8148 47.94 10.0548 47.94ZM14.8264 49H16.5064L17.0764 46.56C17.1964 46.04 17.2764 45.52 17.3864 44.93H17.4364C17.5464 45.52 17.6364 46.03 17.7564 46.56L18.3464 49H20.0764L21.4564 43.4H20.0964L19.4864 46.17C19.3764 46.71 19.3064 47.25 19.2064 47.8H19.1564C19.0364 47.25 18.9364 46.71 18.8064 46.17L18.1064 43.4H16.7964L16.1264 46.17C15.9864 46.7 15.8864 47.25 15.7764 47.8H15.7364C15.6364 47.25 15.5664 46.71 15.4564 46.17L14.8464 43.4H13.3764L14.8264 49ZM24.8811 49.14C25.5811 49.14 26.2911 48.9 26.8411 48.52L26.3411 47.62C25.9411 47.87 25.5411 48.01 25.0811 48.01C24.2511 48.01 23.6511 47.53 23.5311 46.61H26.9811C27.0211 46.48 27.0511 46.21 27.0511 45.94C27.0511 44.39 26.2511 43.26 24.7111 43.26C23.3711 43.26 22.1011 44.39 22.1011 46.21C22.1011 48.05 23.3211 49.14 24.8811 49.14ZM23.5111 45.64C23.6211 44.82 24.1411 44.4 24.7311 44.4C25.4511 44.4 25.7911 44.88 25.7911 45.64H23.5111ZM28.2617 49H29.7217V45.66C30.0417 44.85 30.5717 44.56 31.0117 44.56C31.2417 44.56 31.4017 44.59 31.5917 44.65L31.8517 43.38C31.6817 43.31 31.5017 43.26 31.1917 43.26C30.6117 43.26 30.0117 43.66 29.6017 44.39H29.5617L29.4617 43.4H28.2617V49ZM34.47 49.14C35.05 49.14 35.61 48.82 36.02 48.42H36.05L36.17 49H37.36V41.02H35.89V42.99L35.95 43.87C35.55 43.5 35.16 43.26 34.53 43.26C33.32 43.26 32.18 44.38 32.18 46.21C32.18 48.04 33.08 49.14 34.47 49.14ZM34.85 47.93C34.11 47.93 33.69 47.35 33.69 46.19C33.69 45.07 34.22 44.47 34.85 44.47C35.2 44.47 35.55 44.58 35.89 44.89V47.35C35.57 47.77 35.24 47.93 34.85 47.93ZM44.0111 49.14C45.2411 49.14 46.3911 48.03 46.3911 46.1C46.3911 44.39 45.5611 43.26 44.1811 43.26C43.6311 43.26 43.0711 43.53 42.6311 43.93L42.6611 43.03V41.02H41.2011V49H42.3511L42.4811 48.41H42.5111C42.9711 48.88 43.5111 49.14 44.0111 49.14ZM43.6811 47.93C43.3811 47.93 43.0111 47.82 42.6611 47.51V45.05C43.0511 44.66 43.3911 44.47 43.7711 44.47C44.5411 44.47 44.8811 45.06 44.8811 46.13C44.8811 47.35 44.3611 47.93 43.6811 47.93ZM48.0486 51.25C49.2986 51.25 49.8986 50.49 50.3886 49.17L52.3786 43.4H50.9686L50.1986 46C50.0686 46.52 49.9286 47.06 49.7986 47.58H49.7486C49.5886 47.04 49.4486 46.5 49.2786 46L48.3886 43.4H46.9086L49.0886 48.9L48.9886 49.23C48.8286 49.72 48.5086 50.08 47.9386 50.08C47.8086 50.08 47.6486 50.04 47.5486 50.01L47.2786 51.14C47.4986 51.21 47.7186 51.25 48.0486 51.25Z",
        },
        {
          d:
            "M66.5551 40L63.7219 45.2276L60.8922 40H58L63.7219 50.5695L69.4459 40H66.5551Z",
        },
        {
          d:
            "M78.8431 40L73.1201 50.5695H76.0115L78.8431 45.3417L81.6737 50.5695H84.5639L78.8433 40H78.8431Z",
        },
        {
          d:
            "M107.96 40L102.24 50.5695H105.131L107.96 45.3417L110.793 50.5695H113.685L107.96 40H107.96Z",
        },
        {
          d: "M118.48 40V50.423H121.382V43.0269L127.444 50.423V40H118.48Z",
        },
        {
          d: "M98.977 50.7137H88.0581V40.0693H98.977V50.7137Z",
        },
        {
          d:
            "M90.8831 45.39C90.8831 43.8603 92.26 42.6208 93.9516 42.6208H98.977C97.9397 41.09 96.0834 40.0693 93.9516 40.0693C90.6961 40.0693 88.0581 42.4507 88.0581 45.39C88.0581 48.3303 90.6961 50.7137 93.9516 50.7137C96.0834 50.7137 97.9397 49.6896 98.977 48.1626H93.9516C92.26 48.1626 90.8831 46.9218 90.8831 45.39Z",
        }],
    },
    TaiwanAccessible: {
      width: 40,
      height: 40,
      paths: [
        {
          d:
            "M3.67412 13.8934C4.75443 13.8934 5.62082 13.027 5.62082 11.9467C5.62082 10.8664 4.75443 10 3.67412 10C2.59649 10 1.72743 10.8664 1.72743 11.9467C1.72743 13.027 2.59381 13.8934 3.67412 13.8934ZM1.57501 30.3226V22.5385H0V16.8321C0 15.6903 0.943934 14.7571 2.09912 14.7571H5.2518C6.40698 14.7571 7.35092 15.6903 7.35092 16.8321V22.5385H5.77591V30.3226H1.57501ZM13.8463 24.0948V30.3226H10.8193V24.0948H7.79229L10.354 16.177C10.6268 15.3267 11.4022 14.7544 12.2713 14.7544H12.3916C13.258 14.7544 14.0255 15.324 14.3089 16.177L16.8706 24.0948H13.8463ZM14.2795 11.9467C14.2795 13.027 13.4131 13.8934 12.3328 13.8934C11.2525 13.8934 10.3861 13.027 10.3861 11.9467C10.3861 10.8664 11.2525 10 12.3328 10C13.4131 10 14.2795 10.8664 14.2795 11.9467ZM22.8516 11.9467C22.8516 13.0218 21.98 13.8934 20.9049 13.8934C19.8298 13.8934 18.9582 13.0218 18.9582 11.9467C18.9582 10.8716 19.8298 10 20.9049 10C21.98 10 22.8516 10.8716 22.8516 11.9467ZM20.9644 14.7546C21.8335 14.7546 22.5983 15.3268 22.8817 16.1772L25.4434 24.095H22.4164V30.3228H20.9029H18.8038V22.536H17.2288V16.8296C17.2288 15.6878 18.1727 14.7546 19.3279 14.7546H20.9029H20.9644Z",
        },
        {
          d:
            "M35.1516 12.8151C35.1516 13.8862 34.2833 14.7545 33.2123 14.7545C32.1412 14.7545 31.2729 13.8862 31.2729 12.8151C31.2729 11.744 32.1412 10.8757 33.2123 10.8757C34.2833 10.8757 35.1516 11.744 35.1516 12.8151ZM39.9999 21.5426V19.6032C38.5066 19.6226 37.0036 18.876 36.0533 17.8287L34.8025 16.4421C34.6376 16.2578 34.434 16.1124 34.2109 16.0057C34.2061 16.0057 34.2037 16.0033 34.2013 16.0009C34.1988 15.9984 34.1964 15.996 34.1916 15.996H34.1819C33.8425 15.8021 33.4546 15.7051 33.0279 15.7439C32.0098 15.8312 31.2728 16.733 31.2728 17.7511V23.482C31.2728 24.5486 32.1455 25.4213 33.2122 25.4213H38.0606V30.2697H39.9999V24.9365C39.9999 23.8698 39.1272 22.9971 38.0606 22.9971H35.1515V19.6517C36.4024 20.6893 38.303 21.5329 39.9999 21.5426ZM34.0172 26.3908C33.6197 27.5156 32.5433 28.3301 31.273 28.3301C29.6634 28.3301 28.364 27.0307 28.364 25.4211C28.364 24.1508 29.1785 23.0841 30.3033 22.6769V20.6696C28.0925 21.1157 26.4246 23.0744 26.4246 25.4211C26.4246 28.0974 28.5967 30.2695 31.273 30.2695C33.6197 30.2695 35.5784 28.6016 36.0245 26.3908H34.0172Z",
        },
      ],
    },
    toiletNursingRoom: {
      width: 40,
      height: 40,
      paths: [
        {
          d:
            "M23.9291 15.3647H16.0711C13.612 15.3647 11.6001 17.3867 11.6001 19.8582V35.5065C11.6001 37.978 13.612 40 16.0711 40H23.9291C26.3882 40 28.4001 37.978 28.4001 35.5065V19.8582C28.4001 17.3867 26.3882 15.3647 23.9291 15.3647ZM23.9291 17.7373C25.156 17.7373 26.1543 18.7406 26.1543 19.9737V23.4946L14.1854 36.8038C13.9717 36.4605 13.8459 36.0562 13.8459 35.622V33.0574H16.0333C16.428 33.0574 16.7479 32.7357 16.7479 32.3392C16.7479 31.9425 16.428 31.621 16.0333 31.621H13.8459V28.5161H16.0333C16.428 28.5161 16.7479 28.1945 16.7479 27.7979C16.7479 27.4014 16.428 27.0797 16.0333 27.0797H13.8459V23.9749H16.0333C16.428 23.9749 16.7479 23.6532 16.7479 23.2565C16.7479 22.86 16.428 22.5383 16.0333 22.5383H13.8459V19.9737C13.8459 18.7406 14.8442 17.7373 16.0711 17.7373H23.9291ZM25.4576 7.97319H24.9484C24.9067 6.04377 23.7081 4.38386 22.0142 3.64852V1.92879C22.0142 0.867892 21.1367 0 20.064 0C18.9916 0 18.1139 0.867892 18.1139 1.92879V3.64852C16.42 4.38386 15.2215 6.04377 15.1796 7.97319H14.6707C13.6381 7.97319 12.7935 8.80877 12.7935 9.82986V11.0542C12.7935 12.0752 13.6381 12.9108 14.6707 12.9108H25.4576C26.49 12.9108 27.3348 12.0752 27.3348 11.0542V9.82986C27.3348 8.80877 26.49 7.97319 25.4576 7.97319Z",
        },
      ],
    },
    toiletPowderCorner: {
      width: 40,
      height: 40,
      paths: [
        {
          d:
            "M18.2658 12.7039L17.4028 9.56826L16.5397 12.7039L13.3319 13.5481L16.5397 14.3918L17.4028 17.5279L18.2658 14.3918L21.4737 13.5481L18.2658 12.7039ZM36.3049 32.9297H4V31.6016H36.3049V32.9297ZM24.6098 18.0249L25.0724 19.7053L26.7913 20.1575L25.0724 20.6093L24.6098 22.2898L24.1473 20.6093L22.4284 20.1575L24.1473 19.7053L24.6098 18.0249ZM9.08154 38.856H31.2234C34.0298 38.856 36.3049 36.6318 36.3049 33.8881H4C4 36.6318 6.27506 38.856 9.08154 38.856ZM8.84003 16.3769C8.84003 10.2688 13.9049 5.31718 20.1528 5.31718C26.4002 5.31718 31.4651 10.2688 31.4651 16.3769C31.4651 22.485 26.4002 27.4366 20.1528 27.4366C13.9049 27.4366 8.84003 22.485 8.84003 16.3769ZM36.305 16.591C36.305 7.8698 29.073 0.800049 20.1528 0.800049C11.2321 0.800049 4.00011 7.8698 4.00011 16.591C4.00011 22.7611 7.62194 28.1007 12.8988 30.6992H27.4063C32.6832 28.1007 36.305 22.7611 36.305 16.591Z",
        },
      ],
    },
  });
};
